import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5thtu28bhh: FaireBrandEntity = {
  token: "b_5thtu28bhh",
  type: "brand",
  name: "Hope & Sunshine",
  avatarUrl:
    "https://cdn.faire.com/fastly/f1d532c620443936ad53ec39cf3091a04b529e14785e13adf66454886e7ff422.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2dfc65bdc7ba702cde0d15adb01ab5942b6011d78c97eca1389059abb2557eb6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f1d532c620443936ad53ec39cf3091a04b529e14785e13adf66454886e7ff422.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2dfc65bdc7ba702cde0d15adb01ab5942b6011d78c97eca1389059abb2557eb6.png",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 200,
  rating: 4.5,
  reviewCount: 163,
  isInsider: true,
  description:
    "At Hope and Sunshine, we create contemporary women’s apparel and accessories, providing business-to-business fast fashion solutions built on speed, reliability, and value. Our collection features trendy blouses, cozy knits, chic skirts, elegant midi dresses, and more — all designed in-house with exclusivity and quality in mind.\n\nAll orders include duties and taxes, ensuring hassle-free delivery.\n\nTo help your brand stand out, we offer custom label services for orders of 100 pieces or more.\n\nWe also accept custom apparel orders, with a minimum of 100 pieces per style and color.\n\nPartner with Hope and Sunshine to elevate your business with trendsetting designs, dependable service, and unmatched value — your success is our priority.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:40.759Z",
    importedBy: "entity-db-cli",
  },
};
